module.exports = __webpack_public_path__ + "af6977f4e0df69e1ec84a6c86253ab37.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/car.png
// module id = 2375
// module chunks = 0